import classNames from 'classnames'
import { match } from 'ts-pattern'
import { type ProgressBarSize, ProgressBar } from '../progress/progress-bar'
import { TooltipWithHover } from '../tooltip'
import * as styles from './in-progress-composition-bar.css'

type InProgressBarProps = {
  ariaLabel: string
  progress: number | 'loading'
  size?: ProgressBarSize
}

export const InProgressCompositionBar: React.FC<InProgressBarProps> = ({ ariaLabel, progress, size = 'small' }) => {
  return match(progress)
    .with('loading', () => (
      <div className={classNames(styles.base, styles.baseSize[size])} role="status" aria-label={ariaLabel}>
        <div
          className={classNames(styles.loadingIndicator, styles.loadingIndicatorSize[size])}
          data-testid="progress-bar"
        />
      </div>
    ))
    .otherwise(value => (
      <TooltipWithHover
        side="bottom"
        align="end"
        alignOffset={-36}
        trigger={
          <div>
            <ProgressBar fill="dynamic" size={size} value={value / 100} aria-label={ariaLabel} />
          </div>
        }
      >
        <span className={styles.progressPercentage}>{`${Math.round(value)}%`}</span>
      </TooltipWithHover>
    ))
}
